/**
 * `useApprovalChainDetail(projectId, approvalChainId)` — the canonical read hook for the
 * approval chain creator/editor.
 *
 * Thin `useQuery` wrapper over `approvalChainQuery` so the editor gets the
 * single approval chain (with steps + assignees) via one import while reads still
 * flow through the queryOptions helper (AD-20). Stays idle until both ids are
 * known — create mode passes an undefined `approvalChainId` and never fetches.
 */
import { useQuery } from '@tanstack/react-query';

import { approvalChainQuery } from './approval-chain.api';

export function useApprovalChainDetail(
  projectId: string | undefined,
  approvalChainId: string | undefined,
) {
  return useQuery(approvalChainQuery(projectId, approvalChainId));
}
